import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DidYouKnowBox from "@/components/DidYouKnowBox";
import ProductCTA from "@/components/ProductCTA";
import HeroSection from "@/components/home/HeroSection";
import FeaturedArticles from "@/components/home/FeaturedArticles";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import MissionSection from "@/components/home/MissionSection";
import NewsletterSection from "@/components/home/NewsletterSection";

const featuredArticles = [
  {
    id: 1,
    title: "The Science of Sweat: Understanding Your Body's Natural Cooling System",
    excerpt: "Discover how sweating works and why it's essential for your health and wellbeing.",
    category: "Science",
    image: "/lovable-uploads/30319308-5634-416d-a99c-2c5e83337120.png",
    slug: "/article/science-of-sweat"
  },
  {
    id: 2,
    title: "Natural Deodorants: Do They Really Work?",
    excerpt: "We test 10 popular natural deodorants to see if they can keep up with traditional options.",
    category: "Reviews",
    image: "/lovable-uploads/b59114a6-e1cd-4586-a879-b9b19251e157.png",
    slug: "/article/natural-deodorants"
  },
  {
    id: 3,
    title: "Treating Hyperhidrosis: Options for Excessive Sweating",
    excerpt: "Medical and lifestyle interventions that can help manage excessive underarm sweating.",
    category: "Health",
    image: "/lovable-uploads/6a4f02ea-7f82-498e-b85a-56417434d756.png",
    slug: "/article/hyperhidrosis-treatment"
  }
];

const featuredProducts = [
  {
    id: 9,
    name: "Hey Humans Natural Deodorant",
    price: 12.99,
    rating: 4.7,
    image: "/lovable-uploads/e3ece06c-b176-4067-a58f-bb4f1c09d65a.png",
    slug: "/shop"
  },
  {
    id: 1,
    name: "Grooming Lounge Greatest Pits Deodorant",
    price: 23.00,
    rating: 4.8,
    image: "/lovable-uploads/7553ea87-a17e-481c-b7fb-9548fb2ffd93.png",
    slug: "/shop"
  },
  {
    id: 3,
    name: "Rockwell Double Edge Razor Blades",
    price: 12.49,
    rating: 4.7,
    image: "/lovable-uploads/2abc262b-2602-434c-9ab6-cbf39724a4b0.png",
    slug: "/shop"
  },
  {
    id: 4,
    name: "It Just Works Deodorant",
    price: 35.99,
    rating: 4.6,
    image: "/lovable-uploads/a38e4978-a37a-452c-a67e-140d9acc3d2e.png",
    slug: "/shop"
  }
];

const Index = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className={`flex-grow transition-opacity duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
        <HeroSection />

        <section className="py-6 md:py-8 bg-background">
          <div className="container-custom">
            <ProductCTA 
              variant="banner" 
              message="Try the #1 Natural Deodorant for Healthier Armpits" 
              productName="Breathe Naturals Deodorant"
              productImage="/lovable-uploads/a38e4978-a37a-452c-a67e-140d9acc3d2e.png"
              linkType="breathe1"
            />
          </div>
        </section>

        <DidYouKnowBox />
        
        <FeaturedArticles articles={featuredArticles} />
        
        <FeaturedProducts products={featuredProducts} />
        
        <MissionSection />
        
        <NewsletterSection />
        
        <ProductCTA 
          variant="floating" 
          message="Try our #1 recommended deodorant" 
          linkType="breathe2"
        />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
